import { setUnpublishPending } from '../actions/calendarPublishing';
import getStore from '../store/publishingStore';
import { mutator } from 'satcheljs';

export default mutator(setUnpublishPending, msg => {
    let viewState = getStore().viewState;
    const { folderId, detailLevel, isPending } = msg;

    let publishedCalendar = viewState.publishedCalendarsMap.get(folderId);
    if (publishedCalendar) {
        publishedCalendar.itemStates.forEach(itemState => {
            if (itemState.CurrentDetailLevel == detailLevel) {
                itemState.isUnpublishPending = isPending;
            }
        });
    }
});
